import { useRef, useState } from 'react';
import { getCopy } from '../utils/copy';
import { saveDraft, takeDraft } from './retryDraft';

/**
 * 数值输入题(params.type === 'numeric'):大号输入框 + 确认按钮。
 *
 * 判分在后端(全角数字、单位、容差都由后端容错),这里只保证不提交空答案,
 * 把孩子输入的文字原样(去首尾空格)交给 onAnswer。答错只给温和提示,可无限重试,
 * 重试时保留上次输入。
 */
function NumericPuzzle({ puzzle, onAnswer, feedback, disabled, ageBand }) {
  const { prompt, target, unit, placeholder } = puzzle.params;
  const [value, setValue] = useState(() => takeDraft(puzzle.id, feedback, ''));
  const composing = useRef(false);
  const canSubmit = value.trim() !== '' && !disabled;

  const submit = (e) => {
    e.preventDefault();
    if (!canSubmit || composing.current) return;
    const text = value.trim();
    saveDraft(puzzle.id, value);
    onAnswer(text);
  };

  return (
    <form
      onSubmit={submit}
      className="flex w-full flex-col items-center gap-5 rounded-2xl border-2 border-black bg-white p-5 shadow-brutal sm:p-8"
    >
      <p className="text-lg font-bold text-gray-800">{puzzle.title}</p>
      {prompt && (
        <p data-testid="puzzle-prompt" className="-mt-3 text-center text-lg font-medium text-gray-700">
          {prompt}
        </p>
      )}
      <p className="w-full whitespace-pre-line break-words text-left text-xl leading-relaxed">{target}</p>
      {feedback && !feedback.correct && (
        <p role="alert" className="w-full text-center text-base font-medium text-orange-700">
          {getCopy(ageBand).retryHint}
        </p>
      )}
      <div className="flex w-full items-center gap-2">
        <input
          data-testid="numeric-input"
          type="text"
          inputMode="decimal"
          enterKeyHint="done"
          autoComplete="off"
          aria-label="你的答案"
          value={value}
          disabled={disabled}
          placeholder={placeholder || '输入数字'}
          maxLength={20}
          onChange={(e) => setValue(e.target.value)}
          onCompositionStart={() => { composing.current = true; }}
          onCompositionEnd={() => { composing.current = false; }}
          className="min-h-[56px] min-w-0 flex-1 rounded-xl border-2 border-black bg-amber-50 px-4 text-center text-2xl
                     font-bold text-gray-900 placeholder:text-base placeholder:font-normal placeholder:text-gray-400
                     disabled:opacity-50"
        />
        {unit && <span className="shrink-0 text-xl font-semibold text-gray-700">{unit}</span>}
      </div>
      <button
        type="submit"
        data-testid="numeric-submit"
        disabled={!canSubmit}
        className="min-h-[48px] w-full rounded-lg border-2 border-black bg-qiji-mint px-6 py-3 text-base font-bold
                   text-gray-900 shadow-brutal-sm transition active:translate-y-0 active:shadow-none
                   disabled:cursor-not-allowed disabled:opacity-50"
      >
        就这个答案
      </button>
    </form>
  );
}

export default NumericPuzzle;
